import React from "react"
import { twJoin } from "tailwind-merge"
import Link from "next/link"
import { FeaturesSlider } from "./FeaturesSlider"
import { TrustBanners } from "./TrustBanners"
import Icon from "@components/UI/Icon"
import { MainButton } from "@components/MainButton/MainButton"
import { links } from "@layouts/NavigationV2"
import useUtmTags, { Utm } from "@hooks/useUtmTags";

export const Hero = () => (
  <section className={twJoin("pt-196p pb-80p relative", "bg-neutral2-900", "flex flex-col", "gap-32p 768:gap-48p")}>
    <div
      className={twJoin(
        "absolute",
        "w-full",
        "mx-auto",
        "max-w-[1280px]",
        "h-[200px]",
        "left-[50%]",
        "translate-x-[-50%]",
        "blur-[160px]",
        "bg-[linear-gradient(95.96deg,_rgba(141,_110,_255,_0.3)_0%,_rgba(232,_57,_255,_0.3)_100.43%)]"
      )}
    />
    <div className={twJoin("relative", "flex flex-col gap-32p 768:gap-24p", "p-20p", "1024:p-[unset]")}>
      <h1
        className={twJoin(
          "1024:max-w-[920px]",
          "1280:max-w-[1080px]",
          "mx-auto text-center",
          "text-[32px]",
          "1024:text-[48px]",
          "font-700 leading-[100%] text-neutral2-50 tracking-[-1%]"
        )}
      >
        Time tracking with team and project visibility — without surveillance
      </h1>

      <div className={twJoin("text-center", "text-neutral2-300 text-16p font-400 leading-24p")}>
        Traqq turns tracked time into a clearer picture of workload, projects, and billable work.
      </div>
      <div className={twJoin("flex gap-16p justify-center items-center", "1024:flex-row", "flex-col")}>
        <div className="space-y-2 w-400p max-w-full min-w-0 shrink">
          <MainButton
            href="https://demo.traqq.com"
            target="_blank"
            size={44}
            size1024={56}
            theme={"primary"}
            className={twJoin("w-full gap-12p", "1024:max-w-[unset]", "1024:w-[unset]")}
          >
            <span aria-hidden="true" className="flex shrink-0">
              <Icon name="eye-outline" color="#FFFFFF" size={24} className="flex" />
            </span>
            Explore live demo
          </MainButton>
          <div className={twJoin("hidden", "1024:flex", "flex-row justify-center items-center gap-x-12p text-12p font-400 leading-[100%] text-neutral2-400")}>
            No signup needed
          </div>
        </div>
        <span className="flex items-center gap-8p text-16p 1024:-mt-5">
          <span aria-hidden="true" className="h-px w-12p bg-neutral2-400/50" />
          <span className="text-neutral2-400 font-semibold">
            or
          </span>
          <span aria-hidden="true" className="h-px w-12p bg-neutral2-400/50" />
        </span>
        <div className="space-y-2 w-400p max-w-full min-w-0 shrink">
          <MainButton
            href={useUtmTags(
              `${process.env.NEXT_PUBLIC_APP_TRAQQ_URL}/signup`,
              { utm_medium: Utm.MEDIUM.PAGE, utm_campaign: Utm.CAMPAIGN.BUTTON, utm_term: "Try it completely free" }
            )}
            size={44}
            size1024={56}
            theme={"primary"}
            className={twJoin("w-full gap-12p", "1024:max-w-[unset]", "1024:w-[unset]")}
          >
            <span aria-hidden="true" className="flex shrink-0">
              <Icon name="people-outline" color="#FFFFFF" size={24} className="flex" />
            </span>
            Start your free full-access trial
          </MainButton>
          <div className={twJoin("hidden", "1024:flex", "flex-row justify-center items-center gap-x-12p w-400p")}>
            <span className={twJoin("text-12p font-400 leading-[100%]", "text-neutral2-400")}>No credit card required</span>
            <Icon
              className={""}
              name={"dot-icon"}
              color="neutral2-400"
              size={16}
            />
            <span className={twJoin("text-12p font-400 leading-[100%]", "text-neutral2-400")}>2 minute setup</span>
            <Icon
              className={""}
              name={"dot-icon"}
              color="neutral2-400"
              size={16}
            />
            <span className={twJoin("text-12p font-400 leading-[100%]", "text-neutral2-400")}>Cancel anytime</span>
          </div>
        </div>

        {/*<MainButton
          size={44}
          size1024={56}
          theme={"secondary"}
          href={
            links.REQUEST_DEMO.href +
            "?utm_medium=page&utm_campaign=button&utm_term=Demo&utm_source=main&utm_content=%2F"
          }
          className={twJoin("max-w-[280px] w-full", "1024:max-w-[unset]", "1024:w-[unset]")}
        >
          Book a demo
        </MainButton>*/}
      </div>
    </div>
    <FeaturesSlider />
    <TrustBanners />
  </section>
)
